import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    rowGap: theme.spacing(5),
  },
  sortButton: {
    backgroundColor: "transparent",
    borderColor: "black",
    color: "black",
    borderRadius: theme.spacing(1),
    "&:hover": {
      backgroundColor: "transparent",
      borderColor: "black",
      color: "black",
    },
  },
  addNewButton: {
    borderRadius: theme.spacing(1),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: theme.spacing(20),
  },
  button: {
    width: theme.spacing(30),
    height: theme.spacing(5),
    textTransform: "uppercase",
    fontWeight: "bold",
    borderRadius: theme.spacing(1),
    backgroundColor: "#EB5757",
    color: "white",
    "&:hover": {
      backgroundColor: "#EB5757",
      color: "white",
    },
  },
  deleteButton: {
    backgroundColor: "#fff",
    color: "black",
    "&:hover": {
      backgroundColor: "#fff",
      color: "black",
      opacity: 0.6,
    },
  },
}));

export default useStyles;
